import { GitErrorStatusCode } from './errors/errors.enum';
import { FileNotFoundGitError } from './errors/file-not-found.git-error';
import { FolderNotFoundGitError } from './errors/folder-not-found.git-error';
import { GitCloneGitError } from './errors/git-clone.git-error';
import { GitFetchGitError } from './errors/git-fetch.git-error';
import { GitPullWithConflictError } from './errors/git-pull-with-conflict.git-error';
import { GitPullGitError } from './errors/git-pull.git-error';
import { GitPushClientError } from './errors/git-push-client.git-error';
import { GitPushServerError } from './errors/git-push-server.git-error';
import { GitPushError } from './errors/git-push.git-error';
import { InitGitError } from './errors/init.git-error';
import { NotAFileGitError } from './errors/not-a-file.git-error';
import { NotAFolderGitError } from './errors/not-a-folder.git-error';
import { UnprocessableJSONGitError } from './errors/unprocessable-json.git-error';
import { WriteFileGitError } from './errors/write-file.git-error';
import { GitError } from './wasm-git-worker-errors.model';

export const ErrorCodeToErrorClass: Record<GitErrorStatusCode, new (message: string, append: boolean) => GitError> = {
  [GitErrorStatusCode.NotAFile]: NotAFileGitError,
  [GitErrorStatusCode.NotAFolder]: NotAFolderGitError,
  [GitErrorStatusCode.FolderNotFound]: FolderNotFoundGitError,
  [GitErrorStatusCode.FileNotFound]: FileNotFoundGitError,
  [GitErrorStatusCode.Init]: InitGitError,
  [GitErrorStatusCode.WriteFile]: WriteFileGitError,
  [GitErrorStatusCode.UnprocessableJSON]: UnprocessableJSONGitError,
  [GitErrorStatusCode.GitClone]: GitCloneGitError,
  [GitErrorStatusCode.GitFetch]: GitFetchGitError,
  [GitErrorStatusCode.GitPull]: GitPullGitError,
  [GitErrorStatusCode.GitPushServer]: GitPushServerError,
  [GitErrorStatusCode.GitPushClient]: GitPushClientError,
  [GitErrorStatusCode.GitPush]: GitPushError,
  [GitErrorStatusCode.GitPullWithConflict]: GitPullWithConflictError,
};

export function isGitError(error: unknown): error is GitError {
  return error instanceof GitError;
}

export * from './errors/errors.enum';
export * from './errors/file-not-found.git-error';
export * from './errors/folder-not-found.git-error';
export * from './errors/git-clone.git-error';
export * from './errors/git-fetch.git-error';
export * from './errors/git-pull-with-conflict.git-error';
export * from './errors/git-pull.git-error';
export * from './errors/git-push-client.git-error';
export * from './errors/git-push-server.git-error';
export * from './errors/git-push.git-error';
export * from './errors/init.git-error';
export * from './errors/not-a-file.git-error';
export * from './errors/not-a-folder.git-error';
export * from './errors/unprocessable-json.git-error';
export * from './errors/write-file.git-error';
export * from './wasm-git-worker-errors.model';
